import napStyles from './../nap.json'

export default {
  name: '4',
  type: 'Label',
  default: {
    color: napStyles.colors.PrimaryBlack,
    borderBottom: `1px solid ${napStyles.colors.PrimaryBlack}`
  },
  hover: {
    color: napStyles.colors.SecondaryGreyMetal,
    borderBottom: `1px solid ${napStyles.colors.SecondaryGreyMetal}`
  },
  disabled: {
    color: napStyles.colors.PrimaryGrey,
    borderBottom: `1px solid ${napStyles.colors.PrimaryGrey}`
  }
}
